import "swiper/css";
import "swiper/css/navigation";
import Swiper, { Navigation } from "swiper";
// Timeline Carousel
var timelineCarousel = new Swiper(".swiper-timeline-carousel", {
    modules: [Navigation],
    navigation: {
        nextEl: ".timeline-button-next",
        prevEl: ".timeline-button-prev"
    },
    loop: false,
    allowTouchMove: false,
    slidesPerView: 1,
    spaceBetween: 10
});
